// extracted by mini-css-extract-plugin
export default {"wrapper":"WhyUs_wrapper__EpQHO","grid":"WhyUs_grid__1+6rR","flexBox":"WhyUs_flexBox__QWmVS","gridBox":"WhyUs_gridBox__KT-Fh"};